import AppTabPanel from "./AppTabPanel";

export default AppTabPanel;
